module.exports = __webpack_public_path__ + "static/media/oceania_img5.ca81d444.png";